import { useBondsBondFieldApi } from '../api';

export const useBondsBondSAccOblEndPrice = () => {
  const response = useBondsBondFieldApi('S_ACC.OBL_END_PRICE');
  return response;
};
